import { Dialog } from "@mui/material";
import useAddEditSalaryTemplate from "../../hooks/salaryTemplates/useAddEditSalaryTemplate";
import { Button, Input } from "../ui";
import { useEffect } from "react";

const EditSalaryTemplateModal = ({ isOpen, toggleModal, templateToEdit }) => {
  const {
    control,
    setValue,
    handleSubmit,
    editTemplate,
    onFormError,
    isAdding,
  } = useAddEditSalaryTemplate({
    template: templateToEdit,
    onTemplateEdited: () => {
      toggleModal();
    },
  });

  useEffect(() => {
    if (templateToEdit) {
      setValue("name", templateToEdit.name);
    }
  }, [templateToEdit]);

  return (
    <Dialog open={isOpen} onClose={toggleModal} maxWidth="sm" fullWidth>
      <div className="p-4">
        <h2 className="font-semibold text-xl">Edit Salary Template</h2>

        <form
          onSubmit={handleSubmit(editTemplate, onFormError)}
          className="flex flex-col mt-5"
        >
          <Input
            name="name"
            control={control}
            placeholder="Enter template name"
          />

          <Button type="submit" className={"mx-auto mt-5"} disabled={isAdding}>
            Update Template
          </Button>

          {isAdding && (
            <p className="mt-4 text-center w-full">Updating template...</p>
          )}
        </form>
      </div>
    </Dialog>
  );
};

export default EditSalaryTemplateModal;
